import React, { useMemo, useState, useEffect } from "react";
import { Box, Button, Flex } from "rebass";
import { Form, Formik } from "formik";
import { Checkbox, Label } from "@rebass/forms";

import {
  HR,
  Modal,
  DynamicInput,
  InputTypes,
  CardFooter,
} from "../../../../Components";
import VividVisionSettings from "../../../../VividVisionSettings.json";

const typeMap = {
  "Launcher.ViewModels.NumericSettingVM": InputTypes.Number,
  "Launcher.ViewModels.EnumSettingVM": InputTypes.Radio,
  "Launcher.ViewModels.ToggleSettingVM": InputTypes.CheckBox,
  "System.Windows.Visibility": InputTypes.Ignore,
  "Launcher.ViewModels.TipsVM": InputTypes.Ignore,
};

export const SettingsEditModal: React.FC<{
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  data: any | null;
}> = ({ modalOpen, setModalOpen, data }) => {
  const [customSettings, setCustomSettings] = useState(false);

  useEffect(() => {
    setCustomSettings(data.IsCustomized);
  }, [data]);

  const onSubmit = (values) => {
    console.log(customSettings);
    console.log(values);
  };

  const defaultValues: any = useMemo(
    () =>
      Object.entries(VividVisionSettings[data.Scene]).reduce(
        (accumulator: any, [key, value]: [string, any]) => {
          return {
            ...accumulator,
            [value.Name]:
              data.Settings[value.Name] || value?.Properties?.Value || "",
          };
        },
        {}
      ),
    [data]
  );

  if (!data) {
    return <div></div>;
  }

  return (
    <Modal
      isOpen={modalOpen}
      setIsOpen={setModalOpen}
      headerText={data.Scene || ""}
    >
      <Formik initialValues={defaultValues} onSubmit={onSubmit}>
        <Form>
          <Box padding={3}>
            <Flex>
              <Label>
                <Checkbox
                  onChange={() => {
                    setCustomSettings(!customSettings);
                  }}
                  checked={customSettings}
                />
                Use Custom Settings
              </Label>
            </Flex>
            <HR />
            <Box
              sx={{
                opacity: customSettings ? "1" : "0",
                display: "grid",
                gridTemplateColumns: ["1fr", "1fr 1fr", "1fr 1fr 1fr"],
                columnGap: 3,
                rowGap: 3,
                justifyItems: "center",
              }}
            >
              {Object.entries(VividVisionSettings[data.Scene]).map(
                ([key, value]: [string, any]) => {
                  return (
                    <DynamicInput
                      key={key}
                      formType={{
                        accessor: value.Name,
                        dataType: typeMap[value.Type],
                        Header: value?.Properties?.Label || value.Name,
                        options: value?.Properties?.EnumValues,
                      }}
                    />
                  );
                }
              )}
            </Box>
          </Box>
          <CardFooter>
            <Button type="submit">Save</Button>
          </CardFooter>
        </Form>
      </Formik>
    </Modal>
  );
};
